// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

import '../scss/theme.scss';

function getSwiperSVP(el) {
  const breakpoints = {};

  [...el.attributes].forEach(attr => {
    if (attr.name.startsWith('data-spv-')) {
      const bp = attr.name.replace('data-spv-', '');
      breakpoints[bp] = {
        slidesPerView: Number(attr.value),
        slidesPerGroup: Number(attr.value)
      };
    }
  });

  return breakpoints;
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.swiper');

  carousels.forEach((carousel) => {
    const slides = 1;

    new Swiper(carousel, {
      slidesPerView: Number(slides),
      slidesPerGroup: Number(slides),
      spaceBetween: 24,
      loop: true,
      navigation: {
        nextEl: carousel.querySelector('.swiper-button-next'),
        prevEl: carousel.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      breakpointsBase: 'container',
      breakpoints: getSwiperSVP(carousel)
    });
  });
});

document.addEventListener('DOMContentLoaded', () => {

  const content = document.querySelector('.jem-toc-content');
  const tocList = document.querySelector('.jem-toc-list');
  const headings = content.querySelectorAll('h2');

  if (!headings.length || !tocList) return;

  const slugify = (text) =>
    text.toLowerCase().trim().replace(/[^\w]+/g, '-');

  headings.forEach((heading) => {

    // Add ID if missing
    if (!heading.id) {
      heading.id = slugify(heading.textContent);
    }

    const li = document.createElement('li');
    li.className = `jem-toc-${heading.tagName.toLowerCase()}`;

    const a = document.createElement('a');
    a.href = `#${heading.id}`;
    a.textContent = heading.textContent;

    li.appendChild(a);
    tocList.appendChild(li);
  });


  // Scrollspy
  const tocLinks = tocList.querySelectorAll('a');

  const observer = new IntersectionObserver((entries) => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        tocLinks.forEach(link => link.classList.remove('active'));

        const activeLink = tocList.querySelector(
          `a[href="#${entry.target.id}"]`
        );

        if (activeLink) activeLink.classList.add('active');

      }

    });

  }, {
    rootMargin: "-40% 0px -55% 0px"
  });

  headings.forEach(h => observer.observe(h));

});